<template>
    <!-- main container -->
    <div id="ml_app" style="width: 100%; margin-top: 20px;">

        <!-- process wizard container -->
        <div class="process-wizard-container">

            <!-- process wizard progress summary -->
            <div class="process-wizard-steps">
                <table>
                    <tbody>
                        <tr v-for="(step, index) in wizard_steps" v-bind:key="step.id">
                            <td class="process-wizard-step-icon-container">
                                <div class="process-wizard-step-icon">
                                    <div v-if="step.complete">
                                        <span style="vertical-align: top; position: relative;">
                                            <i class="fa-solid fa-circle" style="position: absolute; top: 5px; left: 0px; color: white;"></i>
                                            <i class="fa-regular fa-circle-check" style="position: absolute; top: 5px; left: 0px; color: rgb(25, 135, 84);"></i>                                                            
                                        </span>
                                    </div>
                                    <div v-else>
                                        <span v-if="step.active" style="vertical-align: top; position: relative;">
                                            <i class="fa-solid fa-circle" style="position: absolute; top: 5px; left: 0px; color: #3978d3;"></i>
                                            <i class="fa-regular fa-circle" style="position: absolute; top: 5px; left: 0px; color: #033276;"></i>                                                            
                                        </span>
                                        <span v-else style="vertical-align: top; position: relative;">
                                            <i class="fa-solid fa-circle" style="position: absolute; top: 5px; left: 0px; color: white;"></i>
                                            <i class="fa-regular fa-circle" style="position: absolute; top: 5px; left: 0px; color: lightgrey;"></i>
                                        </span>
                                    </div>
                                </div>
                                <div v-if="index < wizard_steps.length -1 && step.complete" class="process-wizard-summary-link" style="border-right: 3px solid #00ad5b"></div>
                                <div v-else-if="index < wizard_steps.length -1" class="process-wizard-summary-link"></div>
                            </td>
                            <td class="process-wizard-step-label" :class="step.active ? 'process-wizard-step-label-active' : ''">
                                <span v-if="step.complete">{{  step.label }}</span> 
                                <span v-else>{{  step.label }}</span>
                                <br/><br/>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- process wizard steps -->
            <div class="process-wizard-step-details">
                <div v-for="step in wizard_steps" v-bind:key="step.id">
                    
                    <!-- step 1 -->
                    <div v-if="step.id == 1 && step.active" class="process-wizard-step-step">
                        <h5>{{ step.label }}</h5>

                        <!-- Sample Information -->
                        <div id="sample-information-section" style="max-width: 350px;">

                            <!-- Sample Type Selection -->
                            <div v-if="!sampleTypeSelected">
                                <b-form-group id="sample-type-selection">
                                    <b-form-select v-model="sampleSelected" @change="dropDown_changed()" :options="sampleTypes" size="sm"
                                        class="mt-3"></b-form-select>
                                </b-form-group>
                            </div>
                            <br />

                            <!-- form -->
                            <div v-if="sampleSelected == 'sperm'">
                                <div>
                                    <b-form-group id="ml-input-group-2" label-for="ml-input-2">
                                        <template v-slot:label>
                                            <span>
                                                Pre-Freeze Concentration (10<sup>6</sup>/mL):
                                            </span>
                                        </template>
                                        <b-form-input id="ml-input-2" type="number" inputmode="numeric" ref="ml_input_2" v-model="pre_freeze_concentration"
                                            placeholder="" required
                                            :state="pre_freeze_concentration_valid" size="sm" v-on:keyup.enter="moveto_next_input()"></b-form-input>
                                        <b-form-invalid-feedback :state="pre_freeze_concentration_valid">
                                            input required
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group id="ml-input-group-3" label="Pre-Freeze Motility (%):"
                                        label-for="ml-input-3">
                                        <b-form-input id="ml-input-3" type="number" inputmode="numeric" ref="ml_input_3" v-model="pre_freeze_motility" placeholder=""
                                            required :state="pre_freeze_motility_valid" size="sm" v-on:keyup.enter="wizard_button('forward', current_wizard_step)"></b-form-input>
                                        <b-form-invalid-feedback :state="pre_freeze_motility_valid">
                                            input required
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- step 2 -->
                    <div v-if="step.id == 2 && step.active" class="process-wizard-step-step">
                        <h5>{{ step.label }}</h5>

                        <!-- Package Selection -->
                        <div id="sample-information-section" style="display: flexbox;">

                            <div style="float: left; width: 350px;">
                                <b>Sample Information</b>
                                <table class="table">
                                    <tbody>
                                        <tr>
                                            <td>
                                                Pre-Freeze Concentration
                                            </td>
                                            <td>
                                                {{ pre_freeze_concentration }}*10<sup>6</sup>/mL
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Pre-Freeze Motility
                                            </td>
                                            <td>
                                                {{ pre_freeze_motility }}%
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <!-- ML Result -->
                                <b>Recommended Packaging</b>
                                <div style="float:left; width: 100%;">
                                    <!-- prediction -->
                                    <b-form-input id="ml-input-2" v-model="result.prediction" disabled size="sm"></b-form-input>

                                    <!-- confidence -->
                                    <div style="text-align: right; display: none;">
                                        Confidence {{ result.confidence_percentage }}%
                                    </div>
                                </div>
                            </div>

                            <div style="float: left;">
                                <img v-if="result.prediction == 'Micro Packaging'" style="padding-top: 20px; padding-left: 30px; width: 250px;" src="../../assets/images/templateIcons/testIcons/Micro_Sperm_Packaging_Diagram.png" />
                                <img v-else style="padding-left: 20px; height: 300px; "  src="../../assets/images/templateIcons/testIcons/Macro_Sperm_Packaging_Diagram.png" />
                            </div>

                            <div style="float: left; margin-top: 20px; display: none;">
                                <b-alert show variant="warning">
                                    <i data-v-34cdfe2b="" class="fa-solid fa-circle-exclamation"></i><b style="padding-left: 5px;">Approval Required</b><br/>
                                    <b-form-checkbox id="checkbox-1" v-model="packaging_approved" name="checkbox-1" @click="approve_packaging">
                                        I accept this AI generated selection and approve its use.
                                    </b-form-checkbox>          
                                </b-alert>                      
                            </div>

                        </div>

                    </div>

                    <!-- step 3 -->
                    <div v-if="step.id == 3 && step.active" class="process-wizard-step-step">
                        <h5>{{ step.label }}</h5>

                        

                        <div class="moc_section" style="border: none; padding-top: 0;">
                                <div v-b-toggle.collapse-2 @click="expandCollapse_2()">
                                    <!-- label -->
                                    <span>Phase Charts (Micro Sperm)</span>
                                    <!-- chevron -->
                                    <!-- <i v-bind:class="[section_2_expanded ? 'fa-solid fa-chevron-up chevrons' : 'fa-solid fa-chevron-down chevrons']"></i> -->
                                </div>
                                <b-collapse id="collapse-2" visible class="moc_sub_section">
                                    <!-- loading spinner -->
                                    <div v-if="section_2_processing" style="text-align: center; margin-top: 10px;">
                                        <div class="lds-facebook">
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                        </div>
                                        <div>processing...</div>
                                    </div>

                                    <!-- section 2 content -->
                                    <div v-else style=" overflow: auto;">
                                        <!-- Charts -->

                                        <b-tabs content-class="mt-3" style="margin-bottom: 10px; z-index: 10;">
                                            <b-tab title="Chart 1" active>
                                                <div class="chart-containter" style="display: inline-flexbox;">
                                                        <div title="Submersion Phase (Phase 1)" v-b-popover.hover="'No significant cooling of any part of the sample below -2°c is allowable during this phase. Significant cooling refers to more than 10% of the sample layers area under the curve (AUC) below -2°c for the duration of this phase.'">
                                                            <div v-if="!phase1_planned"><b-spinner small variant="success" label="Spinning"></b-spinner> Phase 1</div>
                                                            <div v-else><i class="fa-solid fa-circle-check success protocol-icon"></i>Phase 1 <i class="fa-solid fa-circle-info" @click="phase1_Clicked" /></div>
                                                            
                                                        </div>
                                                    <div style="position: absolute; z-index: 5; float: right; margin-top: 7%; margin-left: 45%;">
                                                        <div title="Slow Cooling Phase (Phase 2)" v-b-popover.hover="'Precooling combined with packaging design eliminates slow phase cooling from microsperm packaging. To meet the requirements for this phase there should be no period of cooling below an average heat exchange rate of 300°c/min exceeding 5% of the cryopreservation processing time.'">
                                                            <div v-if="!phase2_planned"><b-spinner small variant="success" label="Spinning"></b-spinner> Phase 2</div>
                                                            <div v-else><i class="fa-solid fa-circle-check success protocol-icon"></i>Phase 2 <i class="fa-solid fa-circle-info" @click="phase2_Clicked" /></div>
                                                    
                                                            </div>
                                                            <div style="margin-top: 45%;" title="Rapid Cooling Phase (Phase 3)" v-b-popover.hover="'Rapid cooling must average a heat exchange rate of 300°c/min or greater and may not terminate prior to the average sample temperature exceeding -30°cThe length of time the sample will remain in the machine until is has reached the Cryopreservation conditions.'">
                                                                <div v-if="!phase3_planned"><b-spinner small variant="success" label="Spinning"></b-spinner> Phase 3</div>
                                                                <div v-else><i class="fa-solid fa-circle-check success protocol-icon"></i>Phase 3 <i class="fa-solid fa-circle-info" @click="phase3_Clicked" /></div>
                                                                
                                                            </div>
                                                            <div style="margin-top: 235%;" title="Equilibrium Phase (Phase 4)" v-b-popover.hover="'At the end of the processing timeframe average sample temperature must be below -45°c and within 5% of the heat exchange fluid processing temperature.'">
                                                                <div v-if="!phase4_planned"><b-spinner small variant="success" label="Spinning"></b-spinner> Phase 4</div>
                                                                <div v-else><i class="fa-solid fa-circle-check success protocol-icon"></i>Phase 4 <i class="fa-solid fa-circle-info" @click="phase4_Clicked" /></div>
                                                                
                                                            </div>
                                                        </div>
                                                    <!-- <div class="phaseOverlay phase2-horizontal" v-bind:class="Phase2_Hover">
                                                        <div class="hoverText">
                                                            <div v-if="!phase2_planned"><b-spinner small variant="success" label="Spinning"></b-spinner> Phase 2</div>
                                                            <div v-else><i class="fa-solid fa-circle-check success protocol-icon"></i>Phase 2</div>
                                                        </div>
                                                    </div>
                                                    <div class="phaseOverlay phase3-horizontal" v-bind:class="Phase3_Hover">
                                                        <p class="hoverText"><strong>Phase 3</strong></p>
                                                    </div>
                                                    <div class="phaseOverlay phase4-horizontal" v-bind:class="Phase4_Hover">
                                                        <p class="hoverText"><strong>Phase 4</strong></p>
                                                    </div> -->
                                                    <!-- <div>
                                                        <img style="position: relative; float: right; max-width: 400px; max-height: 400px; z-index: 5;" src="../../assets/images/ML/microsperm-cfd-still.png" />
                                                    </div> -->
                                                   
                                                    <!-- ApexChart Horizontal MicroSperm -->
                                                    <div id="microsperm-chart-horizontal" v-if="microSpermCFD_HorizontalDataLoaded" style="z-index: -5; max-width: 89%; min-width: 89%; float:left;">
                                                        <apexchart id="microsperm_horizontal_chart" type="line" height="450" :options="microspermHorizontalChartOptions" :series="microspermHorizontalChartSeries"></apexchart>
                                                    </div>
                                                    <div id="microsperm-chart-horizontal-brush" v-if="microSpermCFD_HorizontalDataLoaded" style="position: relative; top: -85px; max-width: 89%; min-width: 89%; float:left;">
                                                        <apexchart type="area" height="100" :options="chartOptionsHorizontalBrush" :series="microspermHorizontalChartSeries"></apexchart>
                                                    </div>
                                                </div>
                                            </b-tab>
                                            <b-tab title="Chart 2">
                                                <div class="chart-containter" style="display: inline-flexbox;">
                                                        <div title="Submersion Phase (Phase 1)" v-b-popover.hover="'No significant cooling of any part of the sample below -2°c is allowable during this phase. Significant cooling refers to more than 10% of the sample layers area under the curve (AUC) below -2°c for the duration of this phase.'">
                                                            <div v-if="!phase1_planned"><b-spinner small variant="success" label="Spinning"></b-spinner> Phase 1</div>
                                                            <div v-else><i class="fa-solid fa-circle-check success protocol-icon"></i>Phase 1 <i class="fa-solid fa-circle-info" @click="phase1_Clicked" /></div>
                                                            
                                                        </div>
                                                    <div style="z-index: 5; float: right; margin-top: 10%;">
                                                        <div title="Slow Cooling Phase (Phase 2)" v-b-popover.hover="'Precooling combined with packaging design eliminates slow phase cooling from microsperm packaging. To meet the requirements for this phase there should be no period of cooling below an average heat exchange rate of 300°c/min exceeding 5% of the cryopreservation processing time.'">
                                                            <div v-if="!phase2_planned"><b-spinner small variant="success" label="Spinning"></b-spinner> <span class="phase2-label">Phase 2</span></div>
                                                            <div v-else><i class="fa-solid fa-circle-check success protocol-icon"></i> <span class="phase2-label">Phase 2</span> <i class="fa-solid fa-circle-info" @click="phase2_Clicked" /></div>
                                                    
                                                            </div>
                                                            <div style="margin-top: 45%;" title="Rapid Cooling Phase (Phase 3)" v-b-popover.hover="'Rapid cooling must average a heat exchange rate of 300°c/min or greater and may not terminate prior to the average sample temperature exceeding -30°cThe length of time the sample will remain in the machine until is has reached the Cryopreservation conditions.'">
                                                                <div v-if="!phase3_planned"><b-spinner small variant="success" label="Spinning"></b-spinner> <span class="phase3-label">Phase 3</span></div>
                                                                <div v-else><i class="fa-solid fa-circle-check success protocol-icon"></i> <span class="phase3-label">Phase 3</span> <i class="fa-solid fa-circle-info" @click="phase3_Clicked" /></div>
                                                                
                                                            </div>
                                                            <div style="margin-top: 230%;" title="Equilibrium Phase (Phase 4)" v-b-popover.hover="'At the end of the processing timeframe average sample temperature must be below -45°c and within 5% of the heat exchange fluid processing temperature.'">
                                                                <div v-if="!phase4_planned"><b-spinner small variant="success" label="Spinning"></b-spinner> <span class="phase4-label">Phase 4</span></div>
                                                                <div v-else><i class="fa-solid fa-circle-check success protocol-icon"></i> <span class="phase4-label">Phase 4 </span><i class="fa-solid fa-circle-info" @click="phase4_Clicked" /></div>
                                                                
                                                            </div>
                                                        </div>
                                                    
                                                    <!-- ApexChart Vertical MicroSperm -->
                                                    <div id="microsperm-chart-vertical" v-if="microSpermCFD_VerticalDataLoaded" style="z-index: -5; max-width: 87%; min-width: 87%; float:left;">
                                                        <apexchart type="line" height="450" :options="microspermVerticalChartOptions" :series="microspermVerticalChartSeries"></apexchart>
                                                    </div>
                                                    <div id="microsperm-chart-vertical-brush" v-if="microSpermCFD_VerticalDataLoaded"  style="position: relative; top: -85px; max-width: 87%; min-width: 87%; float:left;">
                                                        <apexchart type="area" height="100" :options="chartOptionsVerticalBrush" :series="microspermVerticalChartSeries"></apexchart>
                                                    </div>
                                                </div>
                                            </b-tab>
                                        </b-tabs>

                                    </div>
                                </b-collapse>
                            </div>
                    </div>

                    <!-- step 4 -->
                    <div v-if="step.id == 4 && step.active" class="process-wizard-step-step">
                        <h5>{{ step.label }}</h5>
                        
                        <!-- Protocol Selection -->
                        <div v-if="section_4_processing" style="text-align: center; margin-top: 10px;">
                            <div class="lds-facebook">
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                            <div>Determining protocol...</div>
                        </div>

                        <!-- section 4 content -->
                        <div v-else>
                            <!-- <b-container>
                                <b-row>
                                    <b-col title="Submersion Phase (Phase 1)" v-b-popover.hover="'No significant cooling of any part of the sample below -2°c is allowable during this phase. Significant cooling refers to more than 10% of the sample layers area under the curve (AUC) below -2°c for the duration of this phase.'">
                                        <div v-if="!phase1_planned"><b-spinner small variant="success" label="Spinning"></b-spinner> Phase 1</div>
                                        <div v-else><i class="fa-solid fa-circle-check success protocol-icon"></i>Phase 1 <i class="fa-solid fa-circle-info" @click="phase1_Clicked" /></div>
                                        
                                    </b-col>
                                    <b-col title="Slow Cooling Phase (Phase 2)" v-b-popover.hover="'Precooling combined with packaging design eliminates slow phase cooling from microsperm packaging. To meet the requirements for this phase there should be no period of cooling below an average heat exchange rate of 300°c/min exceeding 5% of the cryopreservation processing time.'">
                                        <div v-if="!phase2_planned"><b-spinner small variant="success" label="Spinning"></b-spinner> Phase 2</div>
                                        <div v-else><i class="fa-solid fa-circle-check success protocol-icon"></i>Phase 2 <i class="fa-solid fa-circle-info" @click="phase2_Clicked" /></div>
                                        
                                    </b-col>
                                    <b-col title="Rapid Cooling Phase (Phase 3)" v-b-popover.hover="'Rapid cooling must average a heat exchange rate of 300°c/min or greater and may not terminate prior to the average sample temperature exceeding -30°cThe length of time the sample will remain in the machine until is has reached the Cryopreservation conditions.'">
                                        <div v-if="!phase3_planned"><b-spinner small variant="success" label="Spinning"></b-spinner> Phase 3</div>
                                        <div v-else><i class="fa-solid fa-circle-check success protocol-icon"></i>Phase 3 <i class="fa-solid fa-circle-info" @click="phase3_Clicked" /></div>
                                        
                                    </b-col>
                                    <b-col title="Equilibrium Phase (Phase 4)" v-b-popover.hover="'At the end of the processing timeframe average sample temperature must be below -45°c and within 5% of the heat exchange fluid processing temperature.'">
                                        <div v-if="!phase4_planned"><b-spinner small variant="success" label="Spinning"></b-spinner> Phase 4</div>
                                        <div v-else><i class="fa-solid fa-circle-check success protocol-icon"></i>Phase 4 <i class="fa-solid fa-circle-info" @click="phase4_Clicked" /></div>
                                        
                                    </b-col>
                                </b-row>
                                <b-row><b-col><br /></b-col><b-col></b-col><b-col></b-col><b-col></b-col></b-row>
                            </b-container> -->
                            <b-container v-if="phase4_planned == true && recommended_protocol">
                                <b-row>
                                <b-row><b-col><br /></b-col><b-col></b-col><b-col></b-col></b-row>
                                    <b-col><strong>Heat Exchange Conditions</strong></b-col>
                                    <b-col>
                                        <i class="fa-sharp fa-solid fa-water icon ice"></i>{{ recommended_protocol.Flow }} L/min <sup>&#177;{{ recommended_protocol.FlowTol }} L/min</sup>
                                    </b-col>
                                    <b-col>
                                        <i class="fa-solid fa-temperature-half icon ice"></i>{{ recommended_protocol.Temperature }}℃ <sup>&#177;{{ recommended_protocol.TempTol }}℃</sup>
                                    </b-col>
                                </b-row>
                                <b-row><b-col><br /></b-col><b-col></b-col><b-col></b-col></b-row>
                                <b-row><b-col><br /></b-col><b-col></b-col><b-col></b-col></b-row>
                                <b-row>
                                    <b-col>
                                        <strong>Process Time</strong>
                                    </b-col>
                                    <b-col>
                                        <i class="fa-solid fa-clock-rotate-left icon protocol-icon"></i>{{ recommended_protocol.ProcessTime }} seconds
                                    </b-col>
                                    <b-col></b-col>
                                </b-row>
                                <b-row><b-col><br /></b-col><b-col></b-col><b-col></b-col></b-row>
                            </b-container>
                        </div>

                        <div class="moc_section" style="border: none; padding-top: 0;">
                                <div v-b-toggle.collapse-1 @click="expandCollapse_1()">
                                    <!-- label -->
                                    <span>Processing Conditions (Micro Sperm)</span>
                                    <!-- chevron -->
                                    <!-- <i v-bind:class="[section_1_expanded ? 'fa-solid fa-chevron-up chevrons' : 'fa-solid fa-chevron-down chevrons']"></i> -->
                                </div>
                                <b-collapse id="collapse-1" visible class="moc_sub_section">

                                    <!-- loading spinner -->
                                    <div v-if="section_1_processing" style="text-align: center; margin-top: 10px;">
                                        <div class="lds-facebook">
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                        </div>
                                        <div>processing...</div>
                                    </div>

                                    <!-- section 1 content -->
                                    <div v-else>
                                        <!-- Precool -->
                                        <div class="moc_table_heading">Holding Temperature</div>
                                        <div class="moc_table_container">
                                            <!-- <img class="moc_icon" src="../../assets/images/templateIcons/3.png" /> -->
                                            <table class="table moc_table" style="margin-left:0">
                                                <thead>
                                                    <tr>
                                                        <th>Operating Temperature</th>
                                                        <th>Flow Rate</th>
                                                        <th>Processing Time</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>-2°c</td>
                                                        <td>40L/min</td>
                                                        <td>60sec</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <!-- Cryopreservation -->
                                        <div class="moc_table_heading">Cryopreservation</div>
                                        <div class="moc_table_container">
                                            <!-- <img class="moc_icon" src="../../assets/images/templateIcons/4.png" /> -->
                                            <table class="table moc_table" style="margin-left:0">
                                                <thead>
                                                    <tr>
                                                        <th>Operating Temperature</th>
                                                        <th>Flow Rate</th>
                                                        <th>Processing Time</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>-50°c</td>
                                                        <td>60L/min</td>
                                                        <td>60sec</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <!-- Thawing (currently hidden) -->
                                        <!-- <div class="moc_table_heading">Thawing</div>
                                        <div class="moc_table_container">
                                            <img class="moc_icon" src="../../assets/images/templateIcons/6.png" />
                                            <table class="table moc_table">
                                                <thead>
                                                    <tr>
                                                        <th>Operating Temperature</th>
                                                        <th>Flow Rate</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>37.5°c</td>
                                                        <td>45sec</td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div> -->

                                    </div>
                                </b-collapse>
                        </div>
                        
                    </div>
                    
                    <!-- step 5 -->
                    <div v-if="step.id == 5 && step.active" class="process-wizard-step-step">
                        <h5>{{ step.label }}</h5>
                        
                        <!-- Device Selection -->
                        <div v-if="protocol_selected" id="device_selection">
                            
                            <!-- loading spinner -->
                            <div v-if="!deviceDataLoadedStatic" style="text-align: center; margin-top: 10px;">
                                <div class="lds-facebook">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                                <div>Loading device...</div>
                            </div>

                            <div v-else>

                                <!-- card -->
                                <div style="float:left; background-color: white; margin-bottom: 30px; margin-right: 20px">
                                    <!-- image -->
                                    <div class='img-container' style="border:1px solid #47d7ac">
                                        <img class="card-background card-img-top online" style="width: 210px !important; background-color: #f5faff !important;" src="../../assets/images/vcu2.png" alt="...">
                                    </div>
                                    <div class="content-container" style="margin-top: 0px !important; border: 1px solid #adadad; border-top: none; height: 189px !important;">
                                        <span class="status-badge" style="margin-top: 13px;">READY</span>
                                        <h5 class="card-title offline">
                                            <div>Guardion-00011</div>
                                        </h5>
                                        <p class="card-text offline">
                                            Cryopreservation Apparatus<br />
                                        </p>
                                        <div>
                                            <div class="bigTempDataContainer">
                                                <div class="bigTempData belowZero">
                                                    <img class="" src="../../assets/images/snowflake.png" alt="...">
                                                    -42 °C
                                                </div>
                                                <div class="smallTempData">
                                                    10 L/min
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- scheduling -->
                                <div class="deviceSchedule" style="float: left; display: flexbox; margin-left: 10px; margin-top: 5px;">

                                    <div id="datetime-pickers" style="float: right;">
                                        <b-form-datepicker id="device-schedule-date"
                                            v-model="DeviceReadyTime" size="sm" class="mb-2"
                                            :min="minAvailDate" :max="maxAvailDate"
                                            :date-disabled-fn="dateDisabled" locale="en" today-button
                                            reset-button close-button></b-form-datepicker>
                                        <b-form-timepicker id="device-schedule-time" v-model="DeviceReadyTimeTime" hour12
                                            size="sm"></b-form-timepicker>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                    
                    <!-- step 6 -->
                    <div v-if="step.id == 6 && step.active" class="process-wizard-step-step">
                        <h5>{{ step.label }}</h5>

                        <!-- cancelled -->
                        <b-alert :show="scheduleCancelled" variant="danger" dismissible>
                            <p>Device Scheduling Cancelled!</p>
                        </b-alert>

                        <!-- scheduling -->
                        <div v-if="!scheduleCancelled">
                            <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountDown = 0"
                                @dismiss-count-down="countDownChanged">
                                <!--<h5>Scheduled!</h5>-->
                                <p>Device scheduling has been authorised and will be confirmed in {{ dismissCountDown }} seconds... </p>
                                <p><b>Guardion-00011</b> - <b>{{ formatDate(DeviceReadyTime) }}</b> at <b>{{ formatTime(DeviceReadyTimeTime) }}</b></p>
                                <b-progress variant="success" :max="dismissSecs" :value="dismissCountDown" height="4px">
                                </b-progress>
                                <br />
                                <b-button type="button" class="btn btn-danger btn-sm" id="btnCancelSchedule" variant="danger"
                                    @click="cancel_schedule()">
                                    Cancel <i class="fa-solid fa-xmark" style="padding-left: 5px;"></i>
                                </b-button>
                            </b-alert>

                            <!-- confirmation -->
                            <div v-if="!dismissCountDown" style="text-align: center; padding-top: 40px;">
                                
                                <img style="width: 130px;" src="../../assets/images/templateIcons/testIcons/shield-tick.png" />
                                <br /><br />
                                <div>
                                    <b>Guardion-00011</b> has been successfully scheduled for<br />
                                    <b>{{ formatDate(DeviceReadyTime) }}</b> at <b>{{ formatTime(DeviceReadyTimeTime) }}</b>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
                <br /><br />

                <!-- process wizard footer (action buttons)-->
                <div class="process-wizard-footer">
                    <button v-if="!scheduleCancelled && current_wizard_step !== 6" type="button" @click="wizard_button('back')" class="btn btn-secondary btn-sm" style="float: left;">
                        <i class="fa-solid fa-chevron-left"></i><span style="padding-left: 10px;">Back</span>
                    </button> 

                    <button id="wizard_next_button" v-if="current_wizard_step !==6" type="button" @click="wizard_button('forward', current_wizard_step)" class="btn btn-primary btn-sm" style="float: right;"
                        :disabled="(wizard_loading || invalidFormData)">
                        <span v-if="wizard_loading" class="spinner-border spinner-border-sm" style="margin-right: 10px;" role="status" aria-hidden="true"></span>                                    
                        Next<span style="padding-left: 10px;"><i class="fa-solid fa-chevron-right"></i></span>
                    </button>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
/* Import required Chart library */
import VueApexCharts from "vue-apexcharts";

function generateRandomWithLimit(maxLimit = 59) {
    let rand = Math.random() * maxLimit;

    rand = Math.floor(rand).toFixed(0); // 59
    return rand;
}

export default {
    name: 'ml2',
    components: {
        apexchart: VueApexCharts,
    },
    data: function () {
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        // Today
        const minDate = new Date(today)
        // Two days in advance
        const maxDate = new Date(today)
        maxDate.setHours(maxDate.getHours() + 48)
        return {
            //invalidFormData: true,
            DeviceReadyTimeTime: null,
            pre_freeze_concentration: null,
            pre_freeze_motility: null,
            packing_options: [{ value: 0, text: 'Micro Packaging' }, { value: 1, text: 'Macro Packaging' }],
            packing: null,
            result: {
                id: 0,
                pre_freeze_concentration: null,
                pre_freeze_motility: null,
                packing: null,
                prediction: null,
                confidence: null,
                result: null,
            },
            result_history: [],
            show_result: false,
            ML_processing: false,
            pre_freeze_concentration_valid: null,
            pre_freeze_motility_valid: null,
            packing_valid: null,
            id: 0,
            correct_count: 0,
            incorrect_count: 0,
            accuracy: 0,
            training_mode: false,
            modelData: [],
            modelDataTitle: null,

            packaging_approved: true,

            section_0_expanded: true,
            section_1_expanded: true,
            section_2_expanded: true,
            section_3_expanded: true,
            section_4_expanded: true,
            moc_processing: false,
            section_0_processing: true,
            section_1_processing: true,
            section_2_processing: true,
            section_3_processing: true,
            section_4_processing: true,

            section_4_title: 'Protocol Selection',
            protocols: [],
            devices: [],
            chosenDevice: [],
            deviceData: [],
            recommended_protocol: null,
            protocol_selected: false,
            protocol_select_button_text: 'Calculating ',
            phase1_planned: false,
            phase2_planned: false,
            phase3_planned: false,
            phase4_planned: false,

            Phase1_Hover: '',
            Phase2_Hover: '',
            Phase3_Hover: '',
            Phase4_Hover: '',

            DeviceCurrentTemp: null,
            DeviceCurrentFlow: null,
            DeviceReadyTime: null,
            DeviceReadyCounter: null,

            realtimeIntervalID: null,
            deviceDataLoaded: false,
            deviceScheduled: false,
            deviceDataLoadedStatic: false,

            /* Success alert */
            dismissSecs: 10,
            dismissCountDown: 0,
            scheduleCancelled: false,

            minAvailDate: minDate,
            maxAvailDate: maxDate,

            /* Sample Types */
            sampleSelected: null,
            
            sampleTypes: [// TODO: This should live in a DB
                { value: null, text: "Please choose a sample type", disabled: false },
                {
                    label: 'Human',
                    options: [
                        { value: "sperm", text: "Sperm (Human)", disabled: false },
                        { value: "wholeblood", text: "Whole Blood", disabled: true },
                        { value: "plasma", text: "Plasma", disabled: true },
                        { value: "tcell", text: "T-Cell", disabled: true },
                    ]
                },
                {
                    label: 'Aquaculture',
                    options: [
                        { value: "milt", text: "Milt (Salmon)", disabled: true },
                    ]
                }
            ],
            sampleTypeSelected: false,

            /* Form Wizard stuff */
            form_step: 1,
            form_progress: 0,

            /* Form Wizard v2 */
            wizard_steps: [
                {
                    id: 1,
                    label: '1. Sample Information',
                    active: true,
                    complete: false
                },
                {
                    id: 2,
                    label: '2. Package Selection',
                    active: false,
                    complete: false
                },
                {
                    id: 3,
                    label: '3. Protocol Selection',
                    active: false,
                    complete: false
                },
                {
                    id: 4,
                    label: '4. Machine Operating Conditions',
                    active: false,
                    complete: false
                },
                /*{
                    id: 5,
                    label: '5. Charts',
                    active: false,
                    complete: false
                },*/
                {
                    id: 5,
                    label: '5. Device Selection',
                    active: false,
                    complete: false
                },
                {
                    id: 6,
                    label: '6. Device scheduled',
                    active: false,
                    complete: false
                },
            ],
            wizard_loading: false,
            current_wizard_step: 1,
            wizard_complete: false,
            scheduleComplete: false,


            /* ApexChart Setup */
            // MicroSperm Horizontal
            microSpermCFD_HorizontalDataLoaded: false,
            microspermHorizontalChartSeries: [{name: 'Vitrafy MicroSperm', data: [] }],
            microspermHorizontalChartOptions: {
                chart: {
                    id: 'MicroSperm_Horizontal',
                    type: 'line',
                    toolbar: {
                        show: true,
                        autoselected: 'pan',
                    },
                    zoom: {
                        enabled: true,
                        autoScaleYaxis: true
                    },
                    selection: { enabled: false, },
                    stackType: '100%',
                    fill: { opacity: 0.5, },
                },
                colors: ['#94DFFF', '#69A6D1', '#C9EBEF', '#FFD4B1', '#FCADB0', '#FFD4B1', '#C9EBEF', '#69A6D1', '#94DFFF'],
                grid: { show: true, borderColor: '#90A4AE', },
                tooltip: { enabled: true,  onDatasetHover: { highlightDataSeries: true, },},
                legend: { show: true, position: 'top', floating: false, },
                dataLabels: { enabled: false },
                stroke: { curve: 'smooth', width: 1, },
                title: { text: 'MicroSperm - Horizontal', align: 'center' },
                markers: { shape: 'circle', size: 0 },
                xaxis: {
                    type: 'numeric',
                    title: { text: "Physical Time [s]", offsetY: 60,},
                    decimalsInFloat: 0,
                },
                yaxis: {
                    title: { text: "Temperature (Solid) [℃]", rotate: -90 },
                    decimalsInFloat: 0,
                },
                annotations: {
                    xaxis: [],
                    yaxis: [],
                },
            },
            // MicroSperm Vertical
            microSpermCFD_VerticalDataLoaded: false,
            microspermVerticalChartSeries: [{name: 'Vitrafy MicroSperm', data: [] }],
            microspermVerticalChartOptions: {
                chart: {
                    id: 'MicroSperm_Vertical',
                    height: 700,
                    type: 'line',
                    toolbar: {
                        show: true,
                        autoselected: 'pan',
                    },
                    zoom: {
                        enabled: true,
                        autoScaleYaxis: true
                    },
                    selection: {
                        enabled: false,
                        type: 'x',
                    },
                    stackType: '100%',
                    fill: {
                        opacity: 0.5,
                    },
                },
                colors: ['#378BA4', '#2F70AF', '#B9848C', '#a81d4d', '#B9848C', '#2F70AF', '#378BA4'],
                grid: {show: true, borderColor: '#90A4AE',},
                tooltip: { enabled: true, },
                legend: { show: true, position: 'top', floating: false, },
                dataLabels: { enabled: false },
                stroke: { curve: 'smooth', width: 1, },
                title: { text: 'MicroSperm - Vertical', align: 'center' },
                markers: { shape: 'circle', size: 0 },
                xaxis: {
                    type: 'numeric',
                    title: { text: "Physical Time [s]", offsetY: 60,},
                    decimalsInFloat: 0,
                },
                yaxis: {
                    title: { text: "Temperature (Solid) [℃]", rotate: -90 },
                    decimalsInFloat: 0,
                },
                annotations: {
                    xaxis: [],
                    yaxis: [],
                },
            },
            chartOptionsHorizontalBrush: {
                chart: {
                    id: 'MicroSperm_Horizontal_Brush',
                    animations: {
                        enabled: false,
                    },
                    height: 100,
                    type: 'area',
                    brush:{
                        target: 'MicroSperm_Horizontal',
                        enabled: true
                    },
                    selection: {
                        enabled: true,
                    },
                    stackType: '100%',
                },
                colors: ['#94DFFF', '#69A6D1', '#C9EBEF', '#FFD4B1', '#FCADB0', '#FFD4B1', '#C9EBEF', '#69A6D1', '#94DFFF'],
                grid: {show: false, },
                legend: { show:false },
                stroke: { curve: 'smooth', width: 1, },
                fill: {
                    type: 'gradient',
                    gradient: {
                        opacityFrom: 0,
                        opacityTo: 0,
                        inverseColors: true,
                    },                    
                },
                xaxis: {
                    type: 'numeric',
                    decimalsInFloat: 0,
                    tooltip: {
                        enabled: false
                    }
                },
                yaxis: {
                    tickAmount: 2,
                    decimalsInFloat: 0,
                }
            },
            chartOptionsVerticalBrush: {
                chart: {
                    id: 'MicroSperm_Vertical_Brush',
                    animations: {
                        enabled: false,
                    },
                    height: 130,
                    type: 'area',
                    brush:{
                        target: 'MicroSperm_Vertical',
                        enabled: true
                    },
                    selection: {
                        enabled: true,
                    },
                    stackType: '100%',
                },
                colors: ['#378BA4', '#2F70AF', '#B9848C', '#a81d4d', '#B9848C', '#2F70AF', '#378BA4'],
                grid: {show: false, },
                legend: { show: false },
                stroke: { curve: 'smooth', width: 1, },
                fill: {
                    type: 'gradient',
                    gradient: {
                        opacityFrom: 0,
                        opacityTo: 0,
                        inverseColors: true,
                    },                    
                },
                xaxis: {
                    type: 'numeric',
                    decimalsInFloat: 0,
                    tooltip: { enabled: false },
                },
                yaxis: {
                    tickAmount: 2,
                    decimalsInFloat: 0,
                },
            },
        };
    },
    computed: {
        pre_freeze_concentration_validation() {
            if (this.pre_freeze_concentration == null) {
                return false;
            }
            if (this.pre_freeze_concentration.length < 1) {
                return false;
            }
            var x = Number(this.pre_freeze_concentration)
            console.log(x);
            if (Number.isFinite(x)) {
                return true;
            } else {
                return false;
            }
        },
        pre_freeze_motility_validation() {
            if (this.pre_freeze_motility == null) {
                return false;
            }
            if (this.pre_freeze_motility.length < 1) {
                return false;
            }
            var x = Number(this.pre_freeze_motility)
            console.log(x);
            if (Number.isFinite(x)) {
                return true;
            } else {
                return false;
            }
        },
        invalidFormData() {
            return !(
            this.pre_freeze_concentration != null &&
            Number(this.pre_freeze_concentration) > 0 &&
            this.pre_freeze_motility != null &&
            Number(this.pre_freeze_motility) > 0 &&
            this.sampleSelected != null
            );
        }
    },
    props: [],
    watch: {

        DeviceReadyCounter: {
            handler(value) {
                if (value > 0) {
                    setTimeout(() => {
                        if (this.DeviceReadyCounter > 0) this.DeviceReadyCounter--;
                    }, 1000);
                }

            },
            immediate: true // This ensures the watcher is triggered upon creation
        }
    },
    beforeDestroy() {
        clearInterval(this.realtimeIntervalID);
    },
    methods: {
        formatDate(value) {
            const d = value instanceof Date ? value : new Date(value);
            // "Mon Jan 26 2026"
            return d.toDateString();
        },
        formatTime(value) {
            if (value == null || value === '') return '';

            const opts = { hour: 'numeric', minute: '2-digit', hour12: true };

            // If it's already a Date
            if (value instanceof Date) {
                return value.toLocaleTimeString('en-AU', opts);
            }

            // If it's a time-only string like "21:44" / "21:44:06" / "9:44 PM"
            if (typeof value === 'string') {
                const m = value.trim().match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?\s*([AP]M)?$/i);
                if (m) {
                let h = parseInt(m[1], 10);
                const min = parseInt(m[2], 10);
                const sec = m[3] ? parseInt(m[3], 10) : 0;
                const ampm = m[4] ? m[4].toUpperCase() : null;

                if (ampm) {
                    if (ampm === 'PM' && h < 12) h += 12;
                    if (ampm === 'AM' && h === 12) h = 0;
                }

                const d = new Date();
                d.setHours(h, min, sec, 0);

                return d.toLocaleTimeString('en-AU', opts);
                }
            }

            // Fallback: try normal Date parsing
            const d = new Date(value);
            if (isNaN(d.getTime())) return '';

            return d.toLocaleTimeString('en-AU', opts);
        },     
        dropDown_changed()
        {
            // Set focus to the first input box
            console.log("Sample selection changed");
            // Set focus to the next input box
            this.$refs.ml_input_2[0].focus();
        },
        moveto_next_input()
        {
            // Set focus to the next input box
            this.$refs.ml_input_3[0].focus();
        },
        calculate_horizontal_phases()
        {
            console.log("Calculating Phase changes")
/*
            this.microspermVerticalChartSeries.forEach(key => {
                console.log("Key: ")
                console.log(key.name)
                console.log("Value(s): " + key.data)
            });
            console.log*/
        },
        toggle_hover(hovered, phase)
        {
            console.log("Hovered: " + hovered + " Phase: " + phase)
            // if (hovered)
            // {

            // }
        },
        phase1_Clicked()
        {
            console.log("Phase 1 clicked. Current State: " + this.Phase1_Hover);
            /* Toggle the hover state via CSS class manipulation */
            this.Phase1_Hover = (this.Phase1_Hover ? '' : 'hover');
            this.Phase2_Hover = '';
            this.Phase3_Hover = '';
            this.Phase4_Hover = '';
        },
        phase2_Clicked()
        {
            console.log("Phase  clicked. Current State: " + this.Phase1_Hover);
            /* Toggle the hover state via CSS class manipulation */
            this.Phase1_Hover = '';
            this.Phase2_Hover = (this.Phase2_Hover ? '' : 'hover');
            this.Phase3_Hover = '';
            this.Phase4_Hover = '';

            // console.log(this.microspermHorizontalChartOptions.annotations.yaxis)
            // this.microspermHorizontalChartOptions.annotations.yaxis[0].opacity = '.9s';
            // this.microspermHorizontalChartOptions.annotations.yaxis[1].opacity = 9;
            // this.microspermHorizontalChartOptions.annotations.yaxis[2].opacity = .9;
            // console.log(this.microspermHorizontalChartOptions.annotations.yaxis)
        },
        phase3_Clicked()
        {
            console.log("Phase 3 clicked. Current State: " + this.Phase1_Hover);
            /* Toggle the hover state via CSS class manipulation */
            this.Phase1_Hover = '';
            this.Phase2_Hover = '';
            this.Phase3_Hover = (this.Phase3_Hover ? '' : 'hover');
            this.Phase4_Hover = '';
        },
        phase4_Clicked()
        {
            console.log("Phase 4 clicked. Current State: " + this.Phase1_Hover);
            /* Toggle the hover state via CSS class manipulation */
            this.Phase1_Hover = '';
            this.Phase2_Hover = '';
            this.Phase3_Hover = '';
            this.Phase4_Hover = (this.Phase4_Hover ? '' : 'hover');
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        showDeviceScheduledAlert() {
            this.dismissCountDown = this.dismissSecs
        },

        /* process wizard functions */
        async wizard_button(movement, action) {
                console.log("wizard_butto clicked 🤘" + movement + ' action: ' + action);

                // 3 second delay
                this.wizard_loading = true;
                var delay = 0;

                if(movement == 'forward' && !this.wizard_complete) {
                    delay = 500;
                }

                // process action for step
                // -----------------------
                // step 1
                if(action == 1) {
                    await this.test_predict();
                    delay = 0;
                }
                // step 3
                if(action == 4) {
                    this.confirm_protocol_selection();
                }
                // step 6 
                if(action == 5) {
                    this.schedule_device();
                    delay = 0;
                    setTimeout(() => {
                        console.log("😜😅👋")
                        this.wizard_steps[5].complete = true;
                        this.scheduleComplete = true;
                    }, 10000);
                }

                setTimeout(() => {
                    // show loading spinner
                    this.wizard_loading = false;

                    // find current step
                    var current = null;

                    for(var i = 0; i < this.wizard_steps.length; i++) {
                        if(this.wizard_steps[i].active) {
                            current = i+1;
                        }
                    }

                    // find movement direction
                    if(movement == 'forward') {
                        this.wizard_steps[current -1].complete = true;
                        if(current < this.wizard_steps.length) {
                            current = current +1;
                        }
                    } else {
                        current = current -1;
                    }

                    console.log("current " + current);

                    this.current_wizard_step = current;

                    // flag as complete and add NFT to wallet
                    if(this.wizard_steps[this.wizard_steps.length -1].complete && !this.wizard_complete) {
                        this.wizard_complete = true;
                        console.log("WIZARD COMPLETE");
                    }

                    // move
                    if(current > 0 && current < this.wizard_steps.length +1) {
                        current = current -1;
                        for(i = 0; i < this.wizard_steps.length; i++) {
                            if(i == current) {
                                this.wizard_steps[i].active = true;
                            } else {
                                this.wizard_steps[i].active = false;
                            }
                        }
                    }

                    console.log("-----------");
                    console.log("current_wizard_step " + this.current_wizard_step);
                    console.log("wizard_complete " + this.wizard_complete);
                    console.log("-----------");

                }, delay);
        },

        /* Form wizard stuff */
        form_nextStep() {
            this.form_step++;
            this.form_progress = this.form_step * 25;
        },
        form_prevStep() {
            this.form_step--;
            this.form_progress = this.form_step * 25;
        },
        form_reset() {
            this.form_step = 1;
            this.form_progress = 0;
        },

        async test_predict() {
            this.section_0_processing = true;
            this.section_1_processing = true;
            this.section_2_processing = true;
            this.section_3_processing = true;
            this.section_4_processing = true;
            this.protocol_selected = false;
            this.phase1_planned = false;
            this.phase2_planned = false;
            this.phase3_planned = false;
            this.phase4_planned = false;
            this.section_4_title = 'Protocol Selection';
            this.protocol_select_button_text = 'Calculating ';
            this.scheduleCancelled = false;

            // input validation
            this.pre_freeze_concentration_valid = this.pre_freeze_concentration_validation
            this.pre_freeze_motility_valid = this.pre_freeze_motility_validation

            if (this.pre_freeze_concentration_valid && this.pre_freeze_motility_valid) {
                this.show_result = true;
                this.ML_processing = true;

                console.log("predict clicked!");

                var data = {
                    "endpoint": "/ml/gen",
                    "data": {
                        "pre_freeze_concentration": this.pre_freeze_concentration,
                        "pre_freeze_motility": this.pre_freeze_motility
                    }
                }

                data = JSON.stringify(data);

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'authorization': localStorage.idtoken
                };                

                try {
                    const response = await this.$http.post(
                        process.env.VUE_APP_ML_API_URI,
                        data,
                        { headers: headers }
                    );
                    this.result = response.data;

                    if (this.result.prediction == 0) {
                        this.result.prediction = "Micro Packaging"
                    } else {
                        this.result.prediction = "Macro Packaging"
                    }

                    // make confidence a percentage
                    console.log(this.result.confidence)

                    var confidenceArr = this.result.confidence.split(" ");
                    var confidence_percentage = 0;


                    if (this.result.prediction == "Micro Packaging") {
                        confidence_percentage = confidenceArr[0].substring(2);
                        this.result.confidence_percentage = (confidence_percentage * 100).toFixed(2);
                    } else {
                        confidence_percentage = confidenceArr[1].substring(0, confidenceArr[1].length - 2);
                        this.result.confidence_percentage = (confidence_percentage * 100).toFixed(2);
                    }

                    //this.show_result = true;
                    console.log(this.result);
                    this.ML_processing = false;
                    this.pre_freeze_concentration_valid = null;
                    this.pre_freeze_motility_valid = null;
                    this.form_nextStep();

                    // Clear all processing spinners immediately
                    this.moc_processing = false;
                    this.section_4_processing = false;
                    this.section_0_processing = false;
                    this.section_1_processing = false;
                    this.section_2_processing = false;
                    this.section_3_processing = false;
                    this.phase1_planned = true;
                    this.phase2_planned = true;
                    this.phase3_planned = true;
                    this.phase4_planned = true;
                    this.protocol_select_button_text = 'Confirm ';

                    /* Now load the Devices */
                    this.getDevices();

                    /* Now load the Protocols (loads recommended_protocol in background) */
                    this.getProtocols();

                    /* Load CFD chart data directly - does not depend on protocols responding */
                    this.loadMicroSpermCFD();

                    /* Choose appropriate device */
                    this.chooseDevice();
                } catch (error) {
                    console.log(error);
                }
            }
        },
        confirm_protocol_selection() {
            console.log("Confirm button clicked!");

            //for static device
            setTimeout(() => {
                this.deviceDataLoadedStatic = true;
                this.DeviceReadyTimeTime = new Date().toTimeString().slice(0, 8);
            }, 3000);      

            // var me = this;
            // /* Priodically refresh data (currently set to every 5 seconds) */
            // this.realtimeIntervalID = window.setInterval(function () {
            //     /* Load data and attach to card */
            //     //me.chooseDevice();
            //     me.getDeviceData();

            // }, 5000)

            this.DeviceReadyCounter = ((this.DeviceReadyTime - Date.now()) / 1000)
            this.protocol_selected = true;
            this.form_nextStep();
            this.section_4_title = 'Device Selection';
        },
        highlight_horizontal_phase2(hovered)
        {
            console.log("Has been hovered: " + hovered);
        },
        random() {
            this.pre_freeze_concentration = this.genRand(0, 151, 2);
            this.pre_freeze_motility = this.genRand(1, 100, 2);
            this.packing = null;
        },
        genRand(min, max, decimalPlaces) {
            var rand = Math.random() * (max - min) + min;
            var power = Math.pow(10, decimalPlaces);
            return Math.floor(rand * power) / power;
        },
        reset() {
            console.log("history cleared");
            this.result_history = [];
            this.id = 0;
            this.correct_count = 0;
            this.incorrect_count = 0;
            this.accuracy = 0;
            this.show_result = false;
        },
        dateDisabled(ymd, date) {
            // Disable weekends (Sunday = `0`, Saturday = `6`)
            const weekday = date.getDay()
            // Return `true` if the date should be disabled
            return weekday === 0 || weekday === 6
        },
        tab_change() {
            console.log("ML tab changed, form values cleared");
            this.pre_freeze_concentration = null;
            this.pre_freeze_motility = null;
            this.packing = null;
            this.show_result = false;
        },
        approve_packaging()
        {
            this.packaging_approved = !this.packaging_approved; 
        },
        clear() {
            this.form_step = 1;
            this.pre_freeze_concentration = null;
            this.pre_freeze_motility = null;
            this.packing = null;
            this.show_result = false;
            this.moc_processing = true;
            this.section_9_processing = true;
            this.section_1_processing = true;
            this.section_2_processing = true;
            this.section_3_processing = true;
            this.section_4_processing = true;

            clearInterval(this.realtimeIntervalID);
            this.scheduleCancelled = false;
        },
        expandCollapse_0() {
            if (this.section_0_expanded) {
                this.section_0_expanded = false;
            } else {
                this.section_0_expanded = true;
            }
        },
        expandCollapse_1() {
            if (this.section_1_expanded) {
                this.section_1_expanded = false;
            } else {
                this.section_1_expanded = true;
            }
        },
        expandCollapse_2() {
            if (this.section_2_expanded) {
                this.section_2_expanded = false;
            } else {
                this.section_2_expanded = true;
            }
        },
        expandCollapse_3() {
            if (this.section_3_expanded) {
                this.section_3_expanded = false;
            } else {
                this.section_3_expanded = true;
            }
        },
        expandCollapse_4() {
            if (this.section_4_expanded) {
                this.section_4_expanded = false;
            } else {
                this.section_4_expanded = true;
            }
        },
        async loadMicroSpermCFD() {
            let url = process.env.VUE_APP_MULE_PROXY_API_URI;
            let apiheaders = {
                'Content-Type': 'application/json;charset=utf-8',
                'authorization': localStorage.idtoken
            };

            // Fetch Horizontal CFD
            try {
                const hData = JSON.stringify({ "endpoint": "/api/CFD/MicroSperm?elevation=horizontal" });
                const hResponse = await this.$http.post(url, hData, { headers: apiheaders });

                var midcoreData_Horizontal = [], oneBTrailing = [], twoBTrailing = [], threeBTrailing = [],
                    fourBTrailing = [], oneALeading = [], twoALeading = [], threeALeading = [], fourALeading = [];

                for (var j = 0; j < hResponse.data.length; j++) {
                    const d = hResponse.data[j];
                    if (d.CrossSection == 'Mid-Core')    midcoreData_Horizontal.push([d.PhysicalTime, d.Temperature]);
                    if (d.CrossSection == '1B Trailing') oneBTrailing.push([d.PhysicalTime, d.Temperature]);
                    if (d.CrossSection == '2B Trailing') twoBTrailing.push([d.PhysicalTime, d.Temperature]);
                    if (d.CrossSection == '3B Trailing') threeBTrailing.push([d.PhysicalTime, d.Temperature]);
                    if (d.CrossSection == '4B Trailing') fourBTrailing.push([d.PhysicalTime, d.Temperature]);
                    if (d.CrossSection == '1A Leading')  oneALeading.push([d.PhysicalTime, d.Temperature]);
                    if (d.CrossSection == '2A Leading')  twoALeading.push([d.PhysicalTime, d.Temperature]);
                    if (d.CrossSection == '3A Leading')  threeALeading.push([d.PhysicalTime, d.Temperature]);
                    if (d.CrossSection == '4A Leading')  fourALeading.push([d.PhysicalTime, d.Temperature]);
                }

                this.microspermHorizontalChartSeries = [
                    { name: 'A', data: oneALeading }, { name: 'B', data: twoALeading },
                    { name: 'C', data: threeALeading }, { name: 'D', data: fourALeading },
                    { name: 'E', data: midcoreData_Horizontal }, { name: 'F', data: oneBTrailing },
                    { name: 'G', data: twoBTrailing }, { name: 'H', data: threeBTrailing },
                    { name: 'I', data: fourBTrailing },
                ];
                this.microSpermCFD_HorizontalDataLoaded = true;
            } catch (error) {
                console.log('CFD Horizontal load failed:', error);
            }

            // Fetch Vertical CFD
            try {
                const vData = JSON.stringify({ "endpoint": "/api/CFD/MicroSperm?elevation=vertical" });
                const vResponse = await this.$http.post(url, vData, { headers: apiheaders });

                var midcoreData_Vertical = [], oneCUpper = [], twoCUpper = [], threeCUpper = [],
                    oneDLower = [], twoDLower = [], threeDLower = [];

                for (var k = 0; k < vResponse.data.length; k++) {
                    const d = vResponse.data[k];
                    if (d.CrossSection == 'Mid-Core') midcoreData_Vertical.push([d.PhysicalTime, d.Temperature]);
                    if (d.CrossSection == '1C Upper') oneCUpper.push([d.PhysicalTime, d.Temperature]);
                    if (d.CrossSection == '2C Upper') twoCUpper.push([d.PhysicalTime, d.Temperature]);
                    if (d.CrossSection == '3C Upper') threeCUpper.push([d.PhysicalTime, d.Temperature]);
                    if (d.CrossSection == '1D Lower') oneDLower.push([d.PhysicalTime, d.Temperature]);
                    if (d.CrossSection == '2D Lower') twoDLower.push([d.PhysicalTime, d.Temperature]);
                    if (d.CrossSection == '3D Lower') threeDLower.push([d.PhysicalTime, d.Temperature]);
                }

                this.microspermVerticalChartSeries = [
                    { name: 'A', data: oneCUpper }, { name: 'B', data: twoCUpper },
                    { name: 'C', data: threeCUpper }, { name: 'D', data: midcoreData_Vertical },
                    { name: 'E', data: oneDLower }, { name: 'F', data: twoDLower },
                    { name: 'G', data: threeDLower },
                ];
                this.microSpermCFD_VerticalDataLoaded = true;
            } catch (error) {
                console.log('CFD Vertical load failed:', error);
            }
        },
        async getProtocols() {
            /* Get Protocols */
            let url = process.env.VUE_APP_MULE_PROXY_API_URI;

            let apiheaders = {
                'Content-Type': 'application/json;charset=utf-8',
                'authorization': localStorage.idtoken
            };

            var data = {
                "endpoint": "/api/protocols"
            };

            data = JSON.stringify(data);
            console.log("Getting protocols")
            try {
                const response = await this.$http.post(
                    url,
                    data,
                    { headers: apiheaders }
                );

                this.protocols = response.data;

                console.log("Selecction: " + this.result.prediction);

                if (this.result.prediction == 'Micro Packaging') {
                    console.log("Getting MOCs")
                    data = {
                        "endpoint": "/api/mocs/" + 'sperm_micro'
                    };
                    data = JSON.stringify(data);

                    try {
                        const response = await this.$http.post(
                            url,
                            data,
                            { headers: apiheaders }
                        );
                        console.log("MOCs:")
                        console.log(response.data);
                        var moc = response.data;

                        for (var i = 0; i < this.protocols.length; i++) {

                            /* Checks to see if the protocol runs within the tolerance of the Algo */
                            if (((this.protocols[i].Temperature - this.protocols[i].TempTol) <= moc[0].Cryopreservation_Temp) && ((this.protocols[i].Temperature + this.protocols[i].TempTol) >= moc[0].Cryopreservation_Temp)) {
                                /* Choose this protocol to use */
                                this.recommended_protocol = this.protocols[i];
                            }
                        }

                    }
                    catch (error) {
                        console.log(error);
                    }
                    
                    console.log("Getting MicroSperm CFD - Horizontal")
                    data = {
                        "endpoint": "/api/CFD/MicroSperm?elevation=horizontal"
                    };
                    data = JSON.stringify(data);

                    try {
                        const response = await this.$http.post(
                            url,
                            data,
                            { headers: apiheaders }
                        );
                        console.log("Preparing CFD graph data")
                        
                        var midcoreData_Horizontal = []
                        var oneBTrailing = []
                        var twoBTrailing = []
                        var threeBTrailing = []
                        var fourBTrailing = []
                        var oneALeading = []
                        var twoALeading = []
                        var threeALeading = []
                        var fourALeading = []
                        
                        for (var j = 0; j < response.data.length; j++)
                        {
                            if (response.data[j].CrossSection == 'Mid-Core')
                            midcoreData_Horizontal.push([response.data[j].PhysicalTime, response.data[j].Temperature])
                            if (response.data[j].CrossSection == '1B Trailing')
                            oneBTrailing.push([response.data[j].PhysicalTime, response.data[j].Temperature])
                            if (response.data[j].CrossSection == '2B Trailing')
                            twoBTrailing.push([response.data[j].PhysicalTime, response.data[j].Temperature])
                            if (response.data[j].CrossSection == '3B Trailing')
                            threeBTrailing.push([response.data[j].PhysicalTime, response.data[j].Temperature])
                            if (response.data[j].CrossSection == '4B Trailing')
                            fourBTrailing.push([response.data[j].PhysicalTime, response.data[j].Temperature])
                            if (response.data[j].CrossSection == '1A Leading')
                            oneALeading.push([response.data[j].PhysicalTime, response.data[j].Temperature])
                            if (response.data[j].CrossSection == '2A Leading')
                            twoALeading.push([response.data[j].PhysicalTime, response.data[j].Temperature])
                            if (response.data[j].CrossSection == '3A Leading')
                            threeALeading.push([response.data[j].PhysicalTime, response.data[j].Temperature])
                            if (response.data[j].CrossSection == '4A Leading')
                            fourALeading.push([response.data[j].PhysicalTime, response.data[j].Temperature])
                        }

                        this.microspermHorizontalChartSeries = [
                            { name: 'A', data: oneALeading },
                            { name: 'B', data: twoALeading },
                            { name: 'C', data: threeALeading },
                            { name: 'D', data: fourALeading },
                            { name: 'E', data: midcoreData_Horizontal },
                            { name: 'F', data: oneBTrailing },
                            { name: 'G', data: twoBTrailing },
                            { name: 'H', data: threeBTrailing },
                            { name: 'I', data: fourBTrailing },
                        ]
                        
                        this.microspermHorizontalChartOptions.annotations.yaxis = [
                            {
                                y: -1.9,
                                y2: -3.332662,
                                borderColor: '#00E396',
                                fillColor: '#21ecae',
                                opacity: 0.1,
                                width: '100%',
                                label: {
                                    borderColor: '#21ecae',
                                    style: {
                                        color: '#fff',
                                        background: '#21ecae'
                                    },
                                    position: 'right',
                                    textAnchor: 'end',
                                    offsetY: 10,
                                    // text: 'Phase 2',
                                    // mouseEnter: this.toggle_hover(true, 'phase2'),
                                    // mouseLeave: this.toggle_hover(false, 'phase2'),
                                },
                            },
                            {
                                y: -3.332662,
                                y2: -42.45561,
                                borderColor: '#A020F0',
                                fillColor: '#D7A1F9',
                                opacity: 0.1,
                                label: {
                                    borderColor: '#A020F0',
                                    style: {
                                        color: '#fff',
                                        background: '#D7A1F9'
                                    },
                                    position: 'right',
                                    textAnchor: 'end',
                                    offsetY: 60,
                                    // text: 'Phase 3',
                                    // mouseEnter: this.toggle_hover(true, 'phase3'),
                                    // mouseLeave: this.toggle_hover(false, 'phase3'),
                                    // click: this.toggle_hover(false, 'phase3'),
                                },
                            },
                            {
                                y: -42.45561,
                                y2: -50,
                                borderColor: '#0000FF',
                                fillColor: '#7EC8E3',
                                opacity: 0.1,
                                label: {
                                    borderColor: '#0000FF',
                                    style: {
                                        color: '#fff',
                                        background: '#7EC8E3'
                                    },
                                    position: 'right',
                                    textAnchor: 'end',
                                    offsetY: 25,
                                    // text: 'Phase 4',
                                },
                            },
                        ]

                        this.microSpermCFD_HorizontalDataLoaded = true;
                    } catch (error) {
                        console.log(error);
                    }

                    console.log("Getting MicroSperm CFD - Vertical")
                    data = {
                        "endpoint": "/api/CFD/MicroSperm?elevation=vertical"
                    };
                    data = JSON.stringify(data);

                    try {
                        const response = await this.$http.post(
                            url,
                            data,
                            { headers: apiheaders }
                        );
                        console.log("Preparing CFD graph data")
                        
                        var midcoreData_Vertical = []
                        var oneCUpper = []
                        var twoCUpper = []
                        var threeCUpper = []
                        var oneDLower = []
                        var twoDLower = []
                        var threeDLower = []
                        
                        for (var k = 0; k < response.data.length; k++)
                        {
                            if (response.data[k].CrossSection == 'Mid-Core') midcoreData_Vertical.push([response.data[k].PhysicalTime, response.data[k].Temperature])
                            if (response.data[k].CrossSection == '1C Upper') oneCUpper.push([response.data[k].PhysicalTime, response.data[k].Temperature])
                            if (response.data[k].CrossSection == '2C Upper') twoCUpper.push([response.data[k].PhysicalTime, response.data[k].Temperature])
                            if (response.data[k].CrossSection == '3C Upper') threeCUpper.push([response.data[k].PhysicalTime, response.data[k].Temperature])
                            if (response.data[k].CrossSection == '1D Lower') oneDLower.push([response.data[k].PhysicalTime, response.data[k].Temperature])
                            if (response.data[k].CrossSection == '2D Lower') twoDLower.push([response.data[k].PhysicalTime, response.data[k].Temperature])
                            if (response.data[k].CrossSection == '3D Lower') threeDLower.push([response.data[k].PhysicalTime, response.data[k].Temperature])
                        }

                        this.microspermVerticalChartSeries = [
                            { name: 'A', data: oneCUpper },
                            { name: 'B', data: twoCUpper },
                            { name: 'C', data: threeCUpper },
                            { name: 'D', data: midcoreData_Vertical },
                            { name: 'E', data: oneDLower },
                            { name: 'F', data: twoDLower },
                            { name: 'G', data: threeDLower },
                        ]
                        
                        this.calculate_horizontal_phases();

                        this.microspermVerticalChartOptions.annotations.yaxis = [
                            {
                                y: -1.9,
                                y2: -3.332662,
                                borderColor: '#00E396',
                                fillColor: '#21ecae',
                                opacity: 0.1,
                                width: '230%',
                                label: {
                                    borderColor: '#21ecae',
                                    style: {
                                        color: '#fff',
                                        background: '#21ecae'
                                    },
                                    position: 'right',
                                    textAnchor: 'end',
                                    offsetY: 10,
                                    // text: 'Phase 2',
                                },
                            },
                            {
                                y: -3.332662,
                                y2: -42.45561,
                                borderColor: '#A020F0',
                                fillColor: '#D7A1F9',
                                opacity: 0.1,
                                label: {
                                    borderColor: '#A020F0',
                                    style: {
                                        color: '#fff',
                                        background: '#D7A1F9'
                                    },
                                    position: 'right',
                                    textAnchor: 'end',
                                    offsetY: 60,
                                    // text: 'Phase 3',
                                },
                            },
                            {
                                y: -42.45561,
                                y2: -50,
                                borderColor: '#0000FF',
                                fillColor: '#7EC8E3',
                                opacity: 0.1,
                                label: {
                                    borderColor: '#0000FF',
                                    style: {
                                        color: '#fff',
                                        background: '#7EC8E3'
                                    },
                                    position: 'right',
                                    textAnchor: 'end',
                                    offsetY: 25,
                                    // text: 'Phase 4',
                                },
                            },
                        ],
                        

                        this.microSpermCFD_VerticalDataLoaded = true;
                    } catch (error) {
                        console.log(error);
                    }
                }
                
                /* TODO: This is a fallback and will need to be removed when the real algorithm takes over */
                else {

                    console.log("Randomly selected protocol:")
                    var rand = Math.floor(Math.random() * (5 - 1 + 1)) + 1;
                    console.log(rand)
                    // TODO: hook this up to ML model that can determine recommended protocol based on input
                    this.recommended_protocol = this.protocols[rand];
                }
                console.log(this.recommended_protocol);

            } catch (error) {
                console.log(error);
            }
        },
        async getDevices() {
            /* Get Devices */
            let url = process.env.VUE_APP_MULE_PROXY_API_URI;

            let apiheaders = {
                'Content-Type': 'application/json;charset=utf-8',
                'authorization': localStorage.idtoken
            };

            var data = {
                "endpoint": "/api/devices?active=true"
            };

            data = JSON.stringify(data);
            
            try {
                const response = await this.$http.post(
                    url,
                    data,
                    { headers: apiheaders }
                );

                this.devices = response.data;

                this.DeviceReadyTime = new Date(Date.now());
                this.DeviceReadyTime.setMinutes(this.DeviceReadyTime.getMinutes() + parseInt(generateRandomWithLimit(180)));

            } catch (error) {
                console.log(error);
            }
        },
        async chooseDevice() {
            if (!this.devices) return;
            var activeDevices = [];
            /* Filter list to active ones */
            for (var i = 0; i < this.devices.length; i++) {
                var device = this.devices[i];
                if (device.Type == "Cryopreservation Apparatus" && device.Status == "Online" && device.Name != 'Vitrafy-00006') activeDevices.push(device);
            }

            const randIndex = Math.floor(Math.random() * activeDevices.length)
            /* TODO: Choose the device, based on location etc. */
            this.chosenDevice = activeDevices[randIndex];
        },
        async getDeviceData() {
            /* Get Device Data */
            let url = process.env.VUE_APP_MULE_PROXY_API_URI;

            let apiheaders = {
                'Content-Type': 'application/json;charset=utf-8',
                'authorization': localStorage.idtoken
            };

            var data = {
                "endpoint": "/api/devices/" + this.chosenDevice.Name + "/data?mode=stream"
            };

            data = JSON.stringify(data);
            console.log("Getting device data: " + data)
            try {
                const response = await this.$http.post(
                    url,
                    data,
                    { headers: apiheaders }
                );

                this.deviceData = response.data;
                console.log(this.deviceData);

                this.DeviceCurrentTemp = this.deviceData[0][0].TagValue.toFixed(1);
                //this.DeviceCurrentFlow = this.deviceData[2][0].TagValue;
                this.deviceDataLoaded = true;

            } catch (error) {
                console.log(error);
            }
        },
        schedule_device() {
            this.deviceScheduled = true;
            this.showDeviceScheduledAlert();
            this.clear()
        },
        cancel_schedule() {
            this.dismissCountDown = 0;
            this.scheduleCancelled = true;
            console.log("Cancelled job")
        },
    },
    mounted: function () {
        // Initial load of active devices
        this.getDevices();
    }
}
</script>

<style>
#ML_left_pane {
    float: left;
    width: 40%;
}

#ML_right_pane {
    float: left;
    width: 60%;
}

.moc_section {
    float: left;
    width: 100%;
    border-bottom: 1px solid #dee2e6;
    padding-top: 15px;
    padding-bottom: 15px;
}

.moc_section_first {
    border-top: 1px solid #dee2e6;
    /* padding-top: 0px; */
}

.moc_section span {
    font-weight: bold;
}

.chevrons {
    float: right;
    font-size: 18px;
}

.moc_sub_section {
    padding-top: 15px;
    overflow: hidden;
}

.moc_icon {
    width: 53px;
    border: 1px solid grey;
    border-radius: 50%;
    position: absolute;
    top: 10px;
    left: 0;
}

.moc_table_heading {
    /* font-weight: bold; */
    margin-bottom: 4px;
    text-transform: uppercase;
    color: #6c757d;
}

.moc_table_container {
    position: relative;
}

.moc_table {
    margin-left: 70px;
}

.moc_table td {
    width: 33.3%;
}

.moc_table th {
    /* background: #dee2e6 !important; */
    font-weight: normal;
}

.pane_heading {
    margin-bottom: 25px;
}

.summary_title {
    text-transform: uppercase;
}

.summary_data {
    font-size: 40px;
    margin-top: -10px;
    margin-bottom: 30px;
}

.text_red {
    color: red;
}

.text_green {
    color: green;
}

.invalid_select {
    border-color: #dc3545;
}

@media (max-width: 767px) {

    #ML_left_pane,
    #ML_right_pane {
        width: 100% !important;
        padding: 0 !important;
    }

    #ML_right_pane {
        margin-top: 30px;
    }

    .summary_data {
        font-size: 20px;
        font-weight: 700;
        margin-top: 0;
    }

}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.ice {
    color: #0A58CA;
    font-size: 1.2em;
    padding-right: 5px;
}

.success {
    color: #198754;
}

.boxML {
    max-width: 75% !important;
    width: 75% !important;
    height: 200px !important;
    background-color: rgb(247, 247, 247) !important;
    margin: 5px auto;
    margin-left: 5px;
    float: left;
    position: relative;
}

.selection-boxML {
    -webkit-box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
    -moz-box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
    box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);

    display: block;
}

.device-boxML {
    -webkit-box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
    -moz-box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
    box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);

    display: block;
    max-width: 360px !important;
    min-width: 360px !important;
}

.device-detailsML {
    height: 140px !important;
}

.device-img {
    background-color: #68c39f !important;
    margin-right: 10px;
    float: left;
    width: 140px !important;
    height: 140px !important;
}

.device-containerML {
    display: flexbox;
    background: #FFF !important;
}

.bigTempData_MLContainer_ML {
    position: relative;
    width: 360px !important;
}

.bigTempData_MLContainer_ML i {
    position: relative;
    top: 9px;
    left: 6px;
}

.bigTempData_MLContainer_ML img {
    position: relative;
    height: 32px !important;
    top: 9px;
    left: 8px;
    float: left;
}

.bigTempData_ML {
    font-size: 32px;
    text-align: right;
    margin-right: 5%;
}

.smallTempData_ML {
    font-size: 16px;
    text-align: right;
    margin-top: -9px;
    margin-right: 5%;
}

.device-card-footer {
    background-color: #F7F7F7 !important;
    min-height: 60px !important;
    max-height: 60px !important;
    bottom: 0%;
    display: block;
    margin-left: 5%;
}

.deviceReady {
    float: left;
    margin-top: 5%;
}

.deviceSchedule {
    float: right;
}

.protocol-icon {
    padding-right: 5px;
}

#btnConfirmProtocol {
    float: right;
}


/* Form Wizard stuff */
.form-wizard {
    border: 1px solid #ccc;
    padding: 20px;
    max-width: 60%;
    margin-bottom: 20px;
}

.form-wizard-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.form-wizard-header.align-right {
    justify-content: flex-end;
}

.form-wizard-progress {
    width: 100%;
    height: 5px;
    background-color: #ddd;
    margin-top: 10px;
}

.form-wizard-progress div {
    height: 100%;
    background-color: #21ecae;
}

.form-wizard-content {
    margin-top: 20px;
    position: relative;
}

.form-wizard-reset {
    position: absolute;
    bottom: 0;
    right: 0;
    margin: 20px;
}

.form-wizard-reset button {
    background-color: #007bff;
    color: #fff;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.form-wizard-reset button:hover {
    opacity: 0.8;
}

.form-wizard-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 10px;
}

.form-wizard-footer button {
    background-color: #d9d9d9;
    color: #000000;
    font-weight: 700;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
}

.form-back-button {
    border: none;
    border-left: 4px solid #21ecae;
}

.form-next-button {
    border: none;
    border-right: 4px solid #21ecae;
}

.form-wizard-footer button:hover {
    opacity: 0.8;
}

#sample-information-section {
    max-width: 80%;
}

    /* process wizard css */
    .process-wizard-container {
        width: 100%; 
        float: left; 
        padding: 20px; 
        padding-top: 10px;
        padding-bottom: 0;
        padding-right: 0;
        margin-bottom: 50px;
    }

    .process-wizard-steps {
        width: 25%; 
        float: left; 
        padding: 20px; 
        border-right: 1px solid #C7C8C9;
    }

    .process-wizard-step-padding {
        padding-bottom: 20px;
    }

    .process-wizard-step-icon-container {
        position: relative;
        vertical-align: top;
        font-size: 20px;
    }

    .process-wizard-step-icon {
        position: absolute;
        z-index: 1;
    }

    .process-wizard-summary-link {
        position: absolute;
        top: 7px;
        left: 9px;
        width: 3px;
        height: 100%;
        border-right: 3px solid lightgrey;
    }    

    .process-wizard-step-label {
        padding-top: 3px;
        padding-left: 34px;
    }

    .process-wizard-step-label-active {
        font-weight: 700;
    }

    .process-wizard-step-details {
        width: 75%; 
        float: left; 
        padding: 20px;
        padding-bottom: 0;
        padding-right: 0;
    }

    .process-wizard-step-details h5 {
        margin-bottom: 20px;
    }

    .process-wizard-step-step {
        min-height: 310px;
    }

    .process-wizard-footer {
        float: left;
        width: 100%;
    }

    .hideAction {
        display: none;
    }

    .subprocessCompleteButton {
        display: none;
    }   
    
    div.chart-containter { max-width: 770px; width: 770px; }
    
    span.phase2-label 
    {
        border-style: solid;
        border: 1px solid #21ecae;
        border-radius: 8px;
        padding: 1px;
        background-color: #21ecae;
        /* opacity: 100%; */
        z-index: -1;
    } 

    span.phase3-label 
    {
        border-style: solid;
        border: 1px solid #D7A1F9;
        border-radius: 8px;
        padding: 1px;
        background-color: #D7A1F9;
        /* opacity: 100%; */
        z-index: -1;
    } 

    span.phase4-label 
    {
        border-style: solid !important;
        border: 1px solid #7EC8E3 !important;
        border-radius: 8px !important;
        padding: 1px !important;
        background-color: #7EC8E3 !important;
        opacity: 60% !important;
        z-index: -1 !important;
    } 
</style>